import React, { useEffect, useState, useContext } from "react";
import blogFetch from "../../axios/config";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import { Modal } from "react-bootstrap";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import RegisterSector from "./RegisterSector";
import { getIdCompany } from "../../utils/constantes";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import "../../styles/Style.css";

export default function Sector() {
  const [sectors, setSector] = useState({});
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [sectorId, setSectorId] = useState(0);
  const [loading, setLoading] = useState(false);
  const { useRef } = React;

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getSector();
  }, []);

  const ref = useRef();

  const getSector = async () => {
    try {
      let response = await blogFetch.get(`/sector?companyId=${getIdCompany()}`);
      let data = response.data;
      setSector(data);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteSector = async (stR_PK_idSector) => {
    try {
      await blogFetch.delete(`/sector/${stR_PK_idSector}`);
      getSector();
    } catch (error) {
      console.error(error);
    }
  };

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
           {language[selectedCountry.name].Cadastro.setor.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterSector ref={ref}></RegisterSector>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {language[selectedCountry.name].Cadastro.setor.modal.adicionar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addSector();
                setLoading(false);
                setShowModalAdd(false);
                getSector();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.setor.modal.adicionar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.setor.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterSector ref={ref} idSector={sectorId}></RegisterSector>
        </Modal.Body>{" "}
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalEdit(false)}
          >
            {language[selectedCountry.name].Cadastro.setor.modal.editar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateSector();
                setLoading(false);
                setShowModalEdit(false);
                getSector();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.setor.modal.editar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalDelete = () => {
    return (
      <Modal show={showModalDelete} onHide={() => setShowModalDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.setor.modal.deletar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body ref={ref} idSector={sectorId}>
        {language[selectedCountry.name].Cadastro.setor.modal.deletar.corpoModal}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalDelete(false)}>
            {language[selectedCountry.name].Cadastro.setor.modal.deletar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await deleteSector(sectorId);
                setShowModalDelete(false);
                getSector();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.setor.modal.deletar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar title={"Bloco"} />

      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.setor.title}
            </h3>
          </div>
          <div>
            <Button
              className="btn add_button"
              variant="primary"
              onClick={() => {
                setShowModalAdd(true);
              }}
            >
              {language[selectedCountry.name].Cadastro.setor.btnAdicionar}
            </Button>
          </div>
        </div>

        <table className="table table-hover">
          <thead className="table-header">
            <tr className="table_row">
              <th>#</th>
              <th>{language[selectedCountry.name].Cadastro.setor.tableHeader.descricao}</th>
              <th>{language[selectedCountry.name].Cadastro.setor.tableHeader.codSap}</th>
              <th className="edit">{language[selectedCountry.name].Cadastro.setor.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {!!sectors &&
              Object.entries(sectors).map((item) => (
                <tr key={item[1].stR_PK_idSector}>
                  <td>{item[1].stR_PK_idSector}</td>
                  <td>{item[1].stR_description}</td>
                  <td>{item[1].stR_SAPCode}</td>
                  <td className="edit">
                    <center>
                      <ModeEditIcon
                        onClick={() => {
                          setSectorId(item[1].stR_PK_idSector);
                          setShowModalEdit(true);
                        }}
                      />
                    </center>
                  </td>
               
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {modalAdd()}
      {modalDelete()}
      {modalEdit()}
    </>
  );
}
